export default __webpack_public_path__ + "static/media/IconEvent.9d9e62bd.svg";